<template>
  <div>
    <Header :pageIndex="3"/>
    <CBanner img-url="/static/banner7.png" title1="产品中心" title-en="Production" title2="通过PC+移动端多样化的展现，便于经销商及企业内部人员随时随地根据需要处理业务"/>
    <CTitle title="/static/product-example.png" desc="Product case"/>
    <div class="example-list">
      <img src="../../assets/bg7.png" class="bottom-img"/>
      <div v-if="index!=0" class="example-item" @mouseover="changeIndex(0)">
        <img src="../../assets/hlxd_logo.png" class="example-logo"/>
        <div class="white-box"></div>
        <div class="example-name">翰林小店</div>
        <div class="example-line"></div>
        <div class="example-desc">智慧零售小程序，通过拉新裂变，直播引流，形成销售闭环</div>
        <div class="example-button-line">
          <div class="example-button1">销售服务</div>
          <div class="example-button2">商城</div>
        </div>
        <div class="example-detail">了解详情</div>
        <div class="example-item-content">
          <img src="../../assets/hlxd.png" class="app-example-img">
        </div>
        <img src="../../assets/ewm1.png" class="example-item-content2">
        <div class="example-item-content3">了解详情</div>
      </div>
      <div v-else class="example-item2">
        <img src="../../assets/hlxd_logo.png" class="example-logo"/>
        <div class="white-box"></div>
        <div class="example-name">翰林小店</div>
        <div class="example-line"></div>
        <div class="example-desc">智慧零售小程序，通过拉新裂变，直播引流，形成销售闭环</div>
        <div class="example-button-line">
          <div class="example-button1">销售服务</div>
          <div class="example-button2">商城</div>
        </div>
        <div class="example-detail">了解详情</div>
        <div class="example-item-content">
          <img src="../../assets/hlxd.png" class="app-example-img">
        </div>
        <img src="../../assets/ewm1.png" class="example-item-content2">
        <div class="example-item-content3">了解详情</div>
      </div>
      <div v-if="index!=1" class="example-item" @mouseover="changeIndex(1)">
        <img src="../../assets/jsgj_logo.png" class="example-logo"/>
        <div class="white-box"></div>
        <div class="example-name">及时管家</div>
        <div class="example-line"></div>
        <div class="example-desc">提供日常保洁、空调清洗、月嫂保姆、养老护理等服务</div>
        <div class="example-button-line">
          <div class="example-button1">智慧管理</div>
          <div class="example-button2">服务</div>
        </div>
        <div class="example-detail">了解详情</div>
        <div class="example-item-content">
          <img src="../../assets/jsgj.png" class="app-example-img">
        </div>
        <img src="../../assets/ewm3.png" class="example-item-content2">
        <div class="example-item-content3">了解详情</div>
      </div>
      <div v-else class="example-item2">
        <img src="../../assets/jsgj_logo.png" class="example-logo"/>
        <div class="white-box"></div>
        <div class="example-name">及时管家</div>
        <div class="example-line"></div>
        <div class="example-desc">提供日常保洁、空调清洗、月嫂保姆、养老护理等服务</div>
        <div class="example-button-line">
          <div class="example-button1">智慧管理</div>
          <div class="example-button2">服务</div>
        </div>
        <div class="example-detail">了解详情</div>
        <div class="example-item-content">
          <img src="../../assets/jsgj.png" class="app-example-img">
        </div>
        <img src="../../assets/ewm3.png" class="example-item-content2">
        <div class="example-item-content3">了解详情</div>
      </div>
      <div v-if="index!=2" class="example-item" @mouseover="changeIndex(2)">
        <img src="../../assets/tkb_logo.png" class="example-logo"/>
        <div class="white-box"></div>
        <div class="example-name">题库宝</div>
        <div class="example-line"></div>
        <div class="example-desc">多种练习方式，随时随地刷题； 在线完成考试后，自动阅卷评分</div>
        <div class="example-button-line">
          <div class="example-button1">备考刷题</div>
          <div class="example-button2">教育</div>
        </div>
        <div class="example-detail">了解详情</div>
        <div class="example-item-content">
          <img src="../../assets/tkb.png" class="app-example-img">
        </div>
        <img src="../../assets/ewm2.png" class="example-item-content2">
        <div class="example-item-content3">了解详情</div>
      </div>
      <div v-else class="example-item2">
        <img src="../../assets/tkb_logo.png" class="example-logo"/>
        <div class="white-box"></div>
        <div class="example-name">题库宝</div>
        <div class="example-line"></div>
        <div class="example-desc">多种练习方式，随时随地刷题； 在线完成考试后，自动阅卷评分</div>
        <div class="example-button-line">
          <div class="example-button1">备考刷题</div>
          <div class="example-button2">教育</div>
        </div>
        <div class="example-detail">了解详情</div>
        <div class="example-item-content">
          <img src="../../assets/tkb.png" class="app-example-img">
        </div>
        <img src="../../assets/ewm2.png" class="example-item-content2">
        <div class="example-item-content3">了解详情</div>
      </div>
    </div>
    <div class="b2b-graph-section">
      <div class="b2b-graph-bg"></div>
      <CTitle title="/static/bussiness.png" desc="Business introduction"/>
      <div class="b2b-box">
        <div class="join-name">B2B电商</div>
        <div class="join-desc">通过PC+移动端多样化的展现，便于经销商及企业内部人员随时随地根据需要处理业务</div>
        <div class="b2b-graph">
          <div class="b2b-graph-w3">
            <div class="row">
              <div class="row-point"></div>
              <div class="row-text">经销商的PC下单</div>
            </div>
            <div class="row">
              <div class="row-point"></div>
              <div class="row-text">经销商的PC数据查询，所有明细与总览</div>
            </div>
            <div class="row">
              <div class="row-point"></div>
              <div class="row-text">其他操作，如开票申请，返利转让申请等</div>
            </div>
          </div>
          <div class="b2b-graph-w2">
            <div class="row">
              <div class="row-point"></div>
              <div class="row-text">企业内部人员移动审批</div>
            </div>
            <div class="row">
              <div class="row-point"></div>
              <div class="row-text">简单数据的移动查询，如库存查询、每日订单</div>
            </div>
            <div class="row">
              <div class="row-point"></div>
              <div class="row-text">简单数据的移动查询，如库存查询、每日订单</div>
            </div>
          </div>
          <div class="b2b-graph-w1">
            <div class="row">
              <div class="row-point"></div>
              <div class="row-text">经销商的移动下单</div>
            </div>
            <div class="row">
              <div class="row-point"></div>
              <div class="row-text">经销商的移动查询平台</div>
            </div>
            <div class="row">
              <div class="row-point"></div>
              <div class="row-text">经销商的消息平台</div>
            </div>
          </div>
          <div class="b2b-graph-w4">B2B商城</div>
          <div class="b2b-graph-w5">
            <div class="b2b-graph-name">企业号</div>
            <div class="b2b-graph-desc">移动审批+</div>
            <div class="b2b-graph-desc">数据查询</div>
          </div>
          <div class="b2b-graph-w6">
            <div class="b2b-graph-name">微信商城</div>
            <div class="b2b-graph-desc">新增微信</div>
            <div class="b2b-graph-desc">服务号</div>
          </div>
          <div class="b2b-graph-w7">
            <div class="b2b-graph-name">PC商城</div>
            <div class="b2b-graph-desc">升级原有</div>
            <div class="b2b-graph-desc">电商平台</div>
          </div>
        </div>
      </div>
      <CProduct type="simple"/>
    </div>
  </div>
</template>

<script>
  import CBanner from "@/components/CBanner";
  import CTitle from "@/components/CTitle"
  import CProduct from "@/components/CProduct"
  import Header from "../Header";

  export default {
    name: "Production",
    components: {Header, CBanner, CProduct, CTitle},
    data(){
      return{
        index:-1
      }
    },
    methods:{
      changeIndex(index){
        this.index=index
      }
    }
  }
</script>

<style scoped>
  .example-list {
    display: flex;
    justify-content: center;
    position: relative;
  }
  .bottom-img{
    width: 712px;
   height: 712px;
    position: absolute;
    top: 0px;
    left: 50%;
    margin-left: -356px;
    z-index: -1;
  }

  @keyframes example {
    from {transform:rotateY(-180deg);}
    to {transform:rotateY(0deg);}
  }

  .example-item {
    width: 300px;
    height: 575px;
    background: linear-gradient(180deg, #FFFFFF 0%, #FAFBFC 100%);
    box-shadow: 0px 1px 4px 0px rgba(0, 21, 64, 0.14), 0px 7px 14px 0px rgba(0, 21, 64, 0.05), 11px 28px 35px 0px rgba(173, 186, 204, 0.25), 0px 3px 5px 1px #FFFFFF;
    border-radius: 16px;
    margin: 78px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing:border-box;
    cursor: pointer;
    position: relative;
  }
  .example-item2{
    animation-name: example;
    animation-duration: 1s;
    width: 300px;
    height: 575px;
    box-shadow: 0px 18px 58px 0px rgba(7, 57, 163, 0.12);
    border-radius: 16px;
    margin: 78px 30px;
    background-image: linear-gradient(202deg, rgba(48, 225, 255, 1), rgba(9, 25, 201, 1));
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing:border-box;
    cursor: pointer;
  }
  .example-item-content,.example-item-content2,.example-item-content3{
    display: none;
  }

  .example-item2 .example-item-content2{
    position: absolute;
    top: 350px;
    left: 88px;
    width: 124px;
    height: 124px;
    display: block;
    z-index: 11;
  }
  .example-item2 .example-item-content3{
    display: block;
    position: absolute;
    background-color: rgba(12, 22, 239, 1);
    width: 99px;
    height: 34px;
    border-radius: 1px;
    line-height: 33px;
    top: 506px;
    left: 101px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    z-index: 12;
    text-align: center;
    border: solid rgba(255,255,255,0) 1px;
  }
  .example-item2 .example-item-content{
    display: block;
    width: 294px;
    height: 569px;
    background-color: #fff;
    position: absolute;
    top: 3px;
    left: 3px;
    z-index: 10;
    border-radius: 14px;
    text-align: center;
  }
  .app-example-img{
    width: 250px;
    height: 500px;
    margin-top: 30px;
  }

  .example-logo {
    width: 156px;
    height: 156px;
    margin-top: 90px;
  }
  .white-box{
    width: 294px;
    height: 320px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.31) 0%, #FFFFFF 100%);
    border-radius: 0px 0px 14px 14px;
    position: absolute;
    bottom: 3px;
    left: 3px;
    z-index: 11;
    display: none;
  }
  .example-item2 .white-box{
    width: 294px;
    height: 320px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.31) 0%, #FFFFFF 100%);
    border-radius: 0px 0px 14px 14px;
    position: absolute;
    bottom: 3px;
    left: 3px;
    z-index: 11;
  }

  .example-name {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 34px;
    margin-top: 56px;
  }

  .example-line {
    width: 50px;
    height: 5px;
    background: #FCE504;
    border-radius: 4px;
    margin-top: 2px;
  }

  .example-desc {
    width: 250px;
    height: 40px;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #555567;
    line-height: 20px;
    text-align: center;
    margin-top: 29px;
  }

  .example-button-line {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }

  .example-button1 {
    width: 68px;
    height: 32px;
    background-color: rgba(8, 24, 200, 0.08);
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000E92;
    line-height: 32px;
    text-align: center;
  }

  .example-button2 {
    width: 68px;
    height: 32px;
    background-color: rgba(26, 149, 204, 0.08);
    margin-left: 10px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #0089C9;
    line-height: 32px;
    text-align: center;
  }

  .example-detail {
    border: solid #3B43D9 1px;
    width: 99px;
    height: 34px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #291ACC;
    line-height: 33px;
    text-align: center;
    margin-top: 31px;
    border-radius: 1px;
  }

  .b2b-box {
    width: 1070px;
    margin: 50px auto 50px;
  }

  .join-name {
    font-size: 30px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #333333;
    line-height: 45px;
    letter-spacing: 1px;
  }

  .join-desc {
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #081457;
    line-height: 20px;
    margin-top: 16px;
    text-indent: 32px;
    width: 468px;
  }

  .b2b-graph-section {
    width: 100%;
    position: relative;
    height: 1064px;
  }

  .b2b-graph-bg {
    background-image: url("../../assets/bg6.png");
    width: 1920px;
    height: 1064px;
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -960px;
    z-index: -1;
  }

  .b2b-graph {
    width: 313px;
    height: 312px;
    background-image: url("../../assets/qyfw_ywjs.png");
    margin: 60px auto 0;
    position: relative;
  }

  .b2b-graph-w1 {
    position: absolute;
    top: 155px;
    left: 295px;
    width: 259px;
    height: 111px;
    background: #FFFFFF;
    box-shadow: 0px 4px 15px 0px #E8E9F0;
    padding: 24px 0 0 25px;
  }

  .b2b-graph-w2 {
    position: absolute;
    top: -17px;
    left: 250px;
    width: 379px;
    height: 121px;
    background: #FFFFFF;
    box-shadow: 0px 4px 15px 0px #E8E9F0;
    padding: 24px 0 0 25px;
  }

  .b2b-graph-w3 {
    position: absolute;
    top: 120px;
    left: -395px;
    width: 379px;
    height: 114px;
    background: #FFFFFF;
    box-shadow: 0px 4px 15px 0px #E8E9F0;
    padding: 24px 0 0 25px;
  }

  .b2b-graph-w4 {
    font-size: 16px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 24px;
    position: absolute;
    top: 132px;
    left: 141px;
    width: 35px;
  }

  .b2b-graph-w5 {
    /*border: solid 2px blue;*/
    width: 90px;
    height: 100px;
    position: absolute;
    left: 112px;
    top: 42px;
    text-align: center;
  }

  .b2b-graph-w6 {
    /*border: solid 2px blue;*/
    width: 90px;
    height: 100px;
    position: absolute;
    left: 185px;
    top: 170px;
    text-align: center;
  }

  .b2b-graph-w7 {
    /*border: solid 2px blue;*/
    width: 90px;
    height: 100px;
    position: absolute;
    left: 38px;
    top: 170px;
    text-align: center;
  }

  .b2b-graph-name {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #555567;
    line-height: 20px;
    margin-bottom: 2px;
  }

  .b2b-graph-desc {
    font-size: 12px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #555567;
    line-height: 17px;
  }

  .row-point {
    width: 6px;
    height: 6px;
    background: #F0F0F0;
    border: 1px solid #678DFF;
    border-radius: 50%;
    margin-right: 5px;
  }

  .row-text {
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #555567;
    line-height: 29px;
  }
</style>



// WEBPACK FOOTER //
// src/components/contains/Production.vue